export enum ENotificationType {
	CALL = 'call',
	VOICEMAIL = 'voicemail',
	TEXT = 'text',
	ROBOCALL = 'robocall',
	SCENARIO = 'custom_scenario',
	CRM = 'crm_group',
	CALENDAR = 'calendar',
	INTAKE = 'intake',
}

export enum ENotificationMethod {
	EMAIL = 'email',
	SMS = 'sms',
}
